import type { DeviceSerialized } from '@playq/octopus2-devices';
import type { ClientEventSerialized } from '@playq/services-vortex';

interface DeviceInitialState {
  devices: DeviceSerialized[];
  deviceState: [];
  streamEvents: Record<string, ClientEventSerialized[]>;
}
export const deviceState: DeviceInitialState = {
  devices: [],
  deviceState: [],
  streamEvents: {},
};
